export default "__VITE_ASSET__4c6bc3cb__"